import { useAttribute } from "lib/hooks";
import { forwardRef, useState } from "react";

function Table({ style }, ref) {
  const [className] = useAttribute("className", false);
  const [columns, setColumns] = useState(["head1", "head2"]);
  const [rows, setRows] = useState([["col1", "col2"]]);
  function addRow() {
    setRows([...rows, [...columns.map((c, i) => "col" + (i + 1))]]);
  }
  function addColumn() {
    setColumns(columns.concat("head" + (columns.length + 1)));
  }
  return (
    <div className="tc">
      <table {...{ ref, style, className }}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => {
            return (
              <tr key={i}>
                {columns.map((c, j) => (
                  <td key={j}>{r[j] || "col" + (j + 1)}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="aa h" onClick={addRow}>
        <div>
          <i className="fa fa-plus"></i>
        </div>
      </div>
      <div className="aa v" onClick={addColumn}>
        <div>
          <i className="fa fa-plus"></i>
        </div>
      </div>
    </div>
  );
}

export default forwardRef(Table);
